export default "__VITE_ASSET__CkB2EVaA__"